<template>
  <div>
    <el-dialog
      class="l-model"
      :show-close="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :width="width"
      :visible.sync="visible"
      destroy-on-close
      @close="close"
    >
      <a
        v-if="showclose"
        class="close pinter"
        :class="{ outsize: closeoutsize }"
        @click="close"
        ><i class="iconfont icon-fanbaiquxiao"></i
      ></a>
      <slot name="body"> </slot>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'fModel',
  props: {
    visible: {
      default: false
    },
    closeoutsize: {
      default: false
    },
    showclose: {
      default: true
    },
    width: {
      default: '480px'
    }
  },
  data() {
    return {

    };
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
};
</script>
<style lang="scss">
.l-model {
  top: 200px;
  .el-dialog {
    background: transparent;
  }
  .el-dialog__wrapper {
    background: rgba(0, 0, 0, 0);
    backdrop-filter: blur(6px);
  }
  .el-dialog__header {
    padding: 0px;
  }
  .el-dialog__body {
    padding: 0px;
    .close {
      color: #4D4D4D;
      font-size: 32px;
      i {
        font-size: 32px;
      }
      position: absolute;
      z-index: 2;
      right: 60px;
      top: -30px;
      &.outsize {
        right: -33px;
        top: -16px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/lModel/index.vue